import Popper from 'popper.js'

export default {
  install: function (Vue) {
    // 输入框点击后，选中稳重
    Vue.directive('selectTextOnFocus', {
      bind: function (el, binding) {
        function bindDom(el) {
          if (el.tagName !== 'INPUT') {
            [...el.children].forEach(dom => {
              bindDom(dom)
            })
          } else {
            el.onfocus = function () {
              setTimeout(() => {
                el.select()
              }, 30)
            }
            return true
          }
        }

        bindDom(el)
      }
    })
    // 禁止鼠标滚轮造成数字加减
    Vue.directive('removeMouseWheelEvent', {
      bind: function (el, binding) {
        el.onmousewheel = function (e) {
          // e.preventDefault()
          el.blur()
        }

        el.onkeydown = function (e) {
          if ([38, 40].includes(e.keyCode)) {
            e.preventDefault()
          }
        }
      }
    })
    // 自动聚焦
    Vue.directive('focus', {
      inserted: function (el, value) {
        value = value == "undefined" ? true : value;
        if (value) {
          el.focus()
        }
      }
    })
    // 滚动监听
    Vue.directive('scrollListen', {
      bind: function (el, binding) {
        let lastPotion = 0
        let scrollWrap
        if (binding.value && binding.value.el) {
          scrollWrap = el.querySelector(binding.value.el)
        } else {
          scrollWrap = el
        }

        scrollWrap.onmousewheel = function () {
          const distanceRelativeToBottom = this.scrollHeight - this.scrollTop - this.clientHeight
          if (distanceRelativeToBottom === 0) {
            try {
              binding.value.fn({
                direction: 'down',
                scrollTop: this.scrollTop,
                distanceRelativeToBottom
              })
            } catch (e) {
              console.log(e)
            }
          }
        }

        scrollWrap.onscroll = function () {
          const distanceRelativeToBottom = this.scrollHeight - this.scrollTop - this.clientHeight
          const direction = getDirection(lastPotion, this.scrollTop)
          lastPotion = this.scrollTop
          try {
            binding.value.fn({
              direction,
              scrollTop: this.scrollTop,
              distanceRelativeToBottom
            })
          } catch (e) {
            console.log(e)
          }
        }

        function getDirection(last, now) {
          return now - last > 0 ? 'down' : 'up'
        }
      }
    })
    // 防止重复提交
    Vue.directive('noMoreClick', {
      inserted(el, binding) {
        el.addEventListener('click', e => {
          let time = Number(binding.arg) || 2000;
          el.classList.add('is-disabled');
          el.disabled = true;
          setTimeout(() => {
            el.disabled = false;
            el.classList.remove('is-disabled');
          },time)
        })
      }
    })
    // 文字太长... 悬浮展示
    Vue.directive('textPopper', {
      bind: function(el, binding) {
          initTextPopper(el, binding.value)
      },

      update: function(el) {
          if (el.popper) {
              el.popper.destroy()
              el.popper = null
          }

          initTextPopper(el)
      },

      unbind: function(el) {
          if (el.popper) {
              el.popper.destroy()
              el.popper = null
              el.onmouseover = null
              el.onmouseout = null
              el.popperDom = null
          }
      }
    })

    Vue.directive('overText', {
      bind: function(el, binding) {
          initTextPopper2(el, binding.value)
      },

      update: function(el) {
        if (el.popper) {
          el.popper = null
        }
        initTextPopper2(el)
      },

      unbind: function(el) {
        if (el.popper) {
          el.popper = null
          el.onmouseover = null
          el.onmouseout = null
          el.popperDom = null
        }
      }
    })
  }
}

function initTextPopper(el, option = {
  placement: 'top',
  color: '',
  maxWidth: '260px'  // 保证一行最多显示15个字
}) {
  el.onmouseover = function(event) {
      const wrapperWidth = event.currentTarget.clientWidth
      const realWidth = event.currentTarget.scrollWidth
      if (realWidth > wrapperWidth) {
          if (el.popper) {
              el.popperDom.style.display = 'block'
              el.popper.update()
          } else {
              const wrapper = document.createElement('div')
              wrapper.style.zIndex = 30000
              wrapper.style.maxWidth = option.maxWidth
              const div = document.createElement('div')
              div.style.background = '#fff'
              div.style.padding = '10px'
              div.style.borderRadius = '4px'
              div.style.boxShadow = '0px 1px 2px 2px rgba(0, 0, 0, .1)'
              div.style.wordBreak = 'break-all'
              wrapper.appendChild(div)
              const i = document.createElement('i')
              i.style.background = 'white'
              i.style.border = '1px solid rgba(0, 0, 0, 0.1)'
              i.style.width = '12px'
              i.style.height = '12px'
              i.style.transform = 'rotate(45deg)'
              if (option.placement === 'bottom') {
                i.style.top = '-6px'
                i.style.borderRight = 'none'
                i.style.borderBottom = 'none'
              } else {
                i.style.bottom = '-6px'
                i.style.borderTop = 'none'
                i.style.borderLeft = 'none'
              }
              i.style.color = '#fff'
              i.style.left = '50%'
              i.style.fontSize = '20px'
              i.style.position = 'absolute'
              div.appendChild(i)
              const span = document.createElement('span')
              span.style.lineHeight = '24px'
              span.style.color = option.color
              span.innerText = event.currentTarget.innerText
              div.appendChild(span)
              document.body.appendChild(wrapper)
              el.popper = new Popper(event.currentTarget, wrapper, {
                  placement: option.placement,
                  removeOnDestroy: true,
                  modifiers: {
                      offset: {
                          offset: '0,10px,0,0'
                      }
                  }
              })
              el.popperDom = wrapper
          }
      }
  }

  el.onmouseout = function() {
      if (el.popperDom) {
          el.popperDom.style.display = 'none'
      }
  }
}

function initTextPopper2(el) {
  el.onmouseover = function(event) {
      const wrapperWidth = event.currentTarget.clientWidth
      const realWidth = event.currentTarget.scrollWidth
      if (realWidth > wrapperWidth) {
        let placement ='top'
        if (event.currentTarget.innerText.length < 19) {  // 字只有1行
          if (el.getBoundingClientRect().top < 180) placement ='bottom'
        }
        if (event.currentTarget.innerText.length < 37) {  // 字有2行
          if (el.getBoundingClientRect().top < 210) placement ='bottom'
        }
        if (event.currentTarget.innerText.length > 36) {  // 字有3行
          if (el.getBoundingClientRect().top < 230) placement ='bottom'
        }
        const wrapper = document.createElement('div')
        wrapper.style.zIndex = 30000
        wrapper.style.maxWidth = '260px'  // 保证一行最多显示15个字
        // 外层div
        const div = document.createElement('div')
        div.style.background = '#fff'
        div.style.padding = '10px'
        div.style.borderRadius = '4px'
        div.style.boxShadow = '0px 1px 2px 2px rgba(0, 0, 0, .1)'
        div.style.wordBreak = 'break-all'
        wrapper.appendChild(div)
        // 小三角
        const i = document.createElement('div')
        if (placement === 'bottom') {
          i.classList.add('popper-bottom')
        } else {
          i.classList.add('popper-top')
        }
        div.appendChild(i)
        // 承载内容的span元素
        const span = document.createElement('span')
        span.style.lineHeight = '24px'
        span.innerText = event.currentTarget.innerText
        div.appendChild(span)
        document.body.appendChild(wrapper)
        // 将浮窗添加到body上
        el.popper = new Popper(event.currentTarget, wrapper, {
          placement: placement,
          removeOnDestroy: true,
          modifiers: {
            offset: {
              offset: '0,10px,0,0'
            }
          }
        })
        el.popperDom = wrapper
      }
  }

  el.onmouseout = function() {
    if (el.popperDom) document.body.removeChild(el.popperDom)
  }
}